export const storage_keys = {
  "jwt-token": "@cabsol-afms-token",
  "refresh-token": "@cabsol-afms-refresh",
  user: "@cabsol-afms-user",
};

export const apiURL = process.env.REACT_REPORT_BASE;
export const authURL = process.env.REACT_AUTH_BASE;
